/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class InternalServerError extends errors.TruvityError {
    constructor(body: Truvity.ProblemInternalServerError, rawResponse?: core.RawResponse) {
        super({
            message: 'InternalServerError',
            statusCode: 500,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
    }
}
